// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const ko: ChromeTranslations = {
  'nav.nextPage': '다음 쪽 →',
  'nav.previousPage': '← 이전 쪽',
  'nav.continueToLevel': '레벨로 진행 →',
  'nav.backToMenu': '메뉴로 돌아가기 →',
  'howto.page': '{total} 쪽 중 {n} 쪽',
  'options.title': '옵션',
  'ui.language': '언어',
};
